module.exports = __webpack_public_path__ + "static/media/asu_logo.0d25e203.png";